import "../../../../chunk-5WRI5ZAA.js";

// src/visualBuilder/components/icons/fields/index.ts
import { EditIcon } from "../index.js";
var fieldIcons = {
  link: EditIcon,
  json_rte: EditIcon,
  html_rte: EditIcon,
  markdown_rte: EditIcon,
  custom_field: EditIcon,
  isodate: EditIcon,
  url: EditIcon
};
export {
  fieldIcons
};
//# sourceMappingURL=index.js.map